import { Box, Grid } from '@material-ui/core';
import React from 'react';
import TextCard from '../../../../../common/components/cards/textCard';

export default function Health() {
  return (
    <section id="health">
      <p className="body-title mt-4">Saúde</p>
      <p className="h4 mt-4" style={{ color: '#838383', width: '100%' }}>
        Acesse os benefícios odontológicos, psicológicos e de nutrição ofertados
        aos filiados de todo o país.
      </p>

      <Grid
        container
        spacing={3}
        style={{ marginTop: 50, justifyContent: 'center' }}
      >
        <Grid item xs={12} sm={6} md={4}>
          <Box display="flex" justifyContent="center" height="100%">
            <TextCard
              href="#/homepage/saude/agendamento-odontologia-info"
              style={{ height: '100%', width: '100%' }}
            >
              Agendamento de consulta na Clínica Odontolegis
            </TextCard>
          </Box>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Box display="flex" justifyContent="center" height="100%">
            <TextCard
              href="#/homepage/saude/agendamento-psicologia-info"
              style={{ height: '100%', width: '100%' }}
            >
              Agendamento de consulta com psicólogo
            </TextCard>
          </Box>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Box display="flex" justifyContent="center" height="100%">
            <TextCard
              href="#/homepage/saude/agendamento-nutricionista-info"
              style={{ height: '100%', width: '100%' }}
            >
              Agendamento de consulta com nutricionista
            </TextCard>
          </Box>
        </Grid>
      </Grid>
    </section>
  );
}
